module.exports = __webpack_public_path__ + "img/CY110002.a602c177.png";